import { merge } from 'lodash';
import { bigQuery } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { BI_EVENT_GROUPS, BI_ACTION_TYPES } from '../../../../../../shared/services/BIEvents/constants';

const getBasePayLoad = () => {
    const { userId, pageCtxId } = getContext();
    return {
        sub_group: 'ai_video',
        feature: {
            name: 'ai_video_banner',
        },
        page: {
            ctx_id: pageCtxId,
            element: {
                name: 'ai_video_banner',
            },
        },
        user: {
            id: userId,
        },
    };
};

const reportBigQueryImp = (params: Record<string, unknown>) => {
    const payload = merge(
        getBasePayLoad(),
        {
            group: BI_EVENT_GROUPS.USER_IMPRESSION,
            event_triggered_by: BI_ACTION_TYPES.IMPRESSION,
            action: { type: BI_ACTION_TYPES.IMPRESSION },
        },
        params
    );
    bigQuery.send(payload);
};

const reportBigQueryClick = (params: Record<string, unknown>) => {
    const payload = merge(
        getBasePayLoad(),
        {
            group: BI_EVENT_GROUPS.USER_ACTIONS,
            event_triggered_by: BI_ACTION_TYPES.CLICK,
            action: { type: BI_ACTION_TYPES.CLICK },
        },
        params
    );
    bigQuery.send(payload);
};

export const reportAiBannerShown = () => {
    reportBigQueryImp({
        type: 'ai_video_banner_is_shown',
        page: {
            component: {
                name: 'ai_video_banner',
            },
        },
    });
};

export const reportAiBannerClick = () => {
    reportBigQueryClick({
        type: 'click_on_ai_video_banner',
        page: {
            element: {
                type: 'banner',
            },
        },
    });
};
